import { render, staticRenderFns } from "./BusinessStatusCard.vue?vue&type=template&id=22797259&scoped=true"
import script from "./BusinessStatusCard.vue?vue&type=script&lang=js"
export * from "./BusinessStatusCard.vue?vue&type=script&lang=js"
import style0 from "./BusinessStatusCard.vue?vue&type=style&index=0&id=22797259&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22797259",
  null
  
)

export default component.exports